<template>
  <div
    :class="`${containerClasses || ''} ${warning ? 'has-warning' : ''} ${errorToForceUntilIsDirty && !isDirty ? 'has-error' : ''}`"
  >
    <label
      v-if="hasLabel"
      class="control-label bottom-offset1"
    >
      <slot name="label">
        {{ label }}
      </slot>
    </label>
    <div :class="addonContent ? 'input-group' : ''">
      <input
        ref="input"
        v-model.lazy="currencyModel"
        v-money="moneyConfig"
        :autofocus="autofocus"
        :class="`form-control ${inputClasses || ''} ${SIZE[size]}`"
        :disabled="shouldDisable"
        :required="required"
        autocomplete="off"
        :readonly="readonly"
        :name="name"
        :type="type"
        @keydown="checkNegativeCurrency"
        @blur="onBlur ? onBlur() : null"
      >
    </div>
    <div
      v-if="!isValid && !(errorToForceUntilIsDirty && !isDirty)"
      class="invalid-feedback"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { input as inputMixin } from '../mixins';
import { VMoney } from 'v-money'

export default {
  name: 'TrCurrencyField',
  directives: {
    money: VMoney
  },
  mixins: [inputMixin],
  props: ['allowNegativeCurrency'],
  data: () => ({
    type: 'currency',
    lastInternalValue: '',
    moneyConfig: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    }
  }),
  computed: {
    currencyModel: {
      set(value) {
        const realValue = this._getFormattedValue(value);
        if (realValue === -0 || realValue < 0 && !this.allowNegativeCurrency) {
          value = this._toStringValue(realValue * -1);
        }
        this.updateValue(value);
      },
      get() {
        return this.lastInternalValue;
      }
    }
  },
  watch: {
    modelValue(value) {
      if (this._getFormattedValue(this.lastInternalValue) !== value) {
        this.lastInternalValue = this._toStringValue(value);
      }
    }
  },
  created() {
    this.lastInternalValue = this.modelValue;
  },
  methods: {
    checkNegativeCurrency(event) {
      if (this.allowNegativeCurrency) {
        return;
      }

      if (event.key === '-') {
        event.preventDefault();
      }
    },
    _getFormattedValue(value) {
      value = value.slice(3);
      value = value.replace(/\./g, '');
      return Number.parseFloat(String(value).replace(',', '.'));
    },
    _toStringValue(value) {
      value = 'R$ ' + value.toString().replace('.', ',');
      value = !value.includes(',') ? value + ',00' : value;
      return value;
    }
  }
};
</script>
